<script setup lang="ts">
defineProps<{
    items: string[];
}>();
</script>

<template>
    <ul class="privacy-item__list privacy-item-list">
        <li
            v-for="item in items"
            :key="item"
            class="privacy-item-list__item"
        >
            {{ item }}
        </li>
    </ul>
</template>
